module Omni.Booker { 
    export class BedroomOption {
        Count: number;
        Label: string;
    }
    export class ViewOption {
        Value: string;
        Label: string;
    }

    NgModule.component("omniBookerRoomDetails", {
        templateUrl: 'omni-booker-room-details.html',
        bindings: {
            roomDetails: "=",
            propertyDetail: "="   // Two-way
        },
        controller: class OmniBookerRoomDetailsController {
            public roomDetails: RoomDetail;     // binding
            public propertyDetail: PropertyDetail; // binding

            public RoomCountOptions = [1, 2, 3];
            public AdultCountOptions = [1, 2, 3, 4];            
            public ChildCountOptions = [0, 1, 2, 3, 4];
            public ChildAgeOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];

            //Properties for Villas
            public AdultVillasCountOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            public BedroomCountOptions: BedroomOption[] = [];
            public VillasViewOptions: ViewOption[] = [];

            public static $inject = ["$log"];
            constructor(private $log: ng.ILogService) {
                let bedroomCountString = 'bedroom (per Villa)';
                this.BedroomCountOptions.push({ Count: 1, Label: `1   ${bedroomCountString}` });
                this.BedroomCountOptions.push({ Count: 2, Label: `2   ${bedroomCountString}` });
                this.BedroomCountOptions.push({ Count: 3, Label: `3   ${bedroomCountString}` });
                this.BedroomCountOptions.push({ Count: 4, Label: `4+ ${bedroomCountString}` });

                this.VillasViewOptions.push({ Value: "ocean", Label: "Ocean View" });
                this.VillasViewOptions.push({ Value: "nature", Label: "Nature View" });
            }

            private createDefaultRoom(): Room {
                var room = new Room();
                room.AdultCount = 2;
                room.ChildCount = 0;
                return room;
            }

            public onRoomCountChanged() {
                var currentRoomCount = this.roomDetails.Rooms.length;
                var roomCount = this.roomDetails.RoomCount;
                
                if (currentRoomCount === roomCount) {
                    // Nothing to do here
                    return;
                }

                var delta = Math.abs(currentRoomCount - roomCount);
                var adding = currentRoomCount < roomCount;

                if (adding) {
                    // Need to add extra rooms
                    for (var i = 0; i < delta; i++) {
                        var newRoom = this.createDefaultRoom();  
                        this.roomDetails.Rooms.push(newRoom);
                    }
                } else {
                    // Need to remove extra rooms
                    this.roomDetails.Rooms.splice(currentRoomCount - delta, delta);
                }
             
                this.$log.debug("change hit", this.roomDetails);
               
            }

            public onChildCountChanged(room: Room) {
                var currentChildrenCount = room.ChildAges.length;
                var childCount = room.ChildCount;

                if (currentChildrenCount === childCount) {
                    // Nothing to do here
                    return;
                }

                var delta = Math.abs(currentChildrenCount - childCount);
                var adding = currentChildrenCount < childCount;

                if (adding) {
                    // Need to add extra age
                    for (var i = 0; i < delta; i++) {
                        room.ChildAges.push(undefined);
                    }
                } else {
                    // Need to remove extra age
                    room.ChildAges.splice(currentChildrenCount - delta, delta);
                   
                }

                this.$log.debug("change hit", this.roomDetails);
            }
        }
        
    });
}  